export const LOGIN_PAGE = {
  EMAIL_INPUT_PLACEHOLDER: "Enter email address",
  PASSWORD_INPUT_PLACEHOLDER: "Enter password",
  EMAIL: "Email Address",
  PASSWORD: "Password",
  EMAIL_ERROR: "Must be a valid email",
  EMAIL_REQUIRED_MESSAGE: "Email is required",
  PASSWORD_REQUIRED_MESSAGE: "Password is required",
  LOGIN_BUTTON: "Login",
  FORGOT_PASSWORD: "Forgot Password?",
  SEND_REQUEST: "Send Request",
  NEW_PASSWORD: "New Password",
  CONFIRM_PASSWORD: "Confirm Password",
};

export const API_SUCCESS_MESSAGE = {
  LOGIN_SUCCESS: "Logged in successfully",
  FETCHED_SUCCESSFULLY: "Data fetched successfully",
  LOGGED_OUT: "Logged out successfully",
  USER_CONVERSATON: "User conversations fetched successfully",
  USER_DETAILS: "Users details fetched successfully",
  LISTING_FETCH: "Details fetched successfully",
  TASK_CREATED: "Task created successfully",
  TASK_UPDATED: "Task updated successfully",
  TASK_DELETED: "Task deleted successfully",
  OTP_SENT: "One Time Pin sent successfully",
  DELETED_SUCCESSFULLY: "Deleted successfully",
  UPDATED_SCUCESSFULLY: "Updated successfully",
  UNSUBSCRIBED_SUCCESSFULLY: "User Unsubscribed successfully",
  DOWNLOAD_REEL:"Your tile is now downloaded to your 'files' folder!",
};

export const API_ERROR_MESSAGE = {
  INVALID_PASSWORD: "Invalid Password",
  INTERNAL_SERVER_ERROR: "Internal server error",
  INCORRECT_EMAIL: "Email Id is not valid",
};

export const STORAGE_KEYS = {
  AUTH_INFO: "_AUTH_INFO",
  AUTH_TOKEN: "_AUTH_TOKEN",
  RESOURCE_PERMISSIONS: "RESOURCE_PERMISSIONS",
  USER_INFO: "USER_INFO",
  USER_SYSTEM_SETTINGS: "USER_SYSTEM_SETTINGS",
};

export const DASHBOARD = {
  ADMIN: "Admin",
  AIPLAYGROUND: "AI Playground",
  SCHEDULEMESSAGES: "Schedule Messages Configuration",
  INSIGHTS: "Insights",
  PAGE_TITLE: "Dashboard",
  WELCOME_MESSAGE: "Welcome back! Select an option to continue:",
  TEST_ENVIRONMENT: "Test Environment",
  PLANS: "Plans",
  PAYMENTS: "Payments",
  UIRECOMMENDATIONS: "UI Recommendations",
};
export const CARD_COLORS = {
  ADMIN: "#2F54EB",
  AIPLAYGROUND: "#5AD1C8",
  INSIGHTS: "#F39ACF",
};

export const VALIDATON_TEXT = {
  CHARACTER_LIMIT: "Password must be at least 8 characters",
  UPPERCASE: "Password must contain at least one uppercase letter",
  LOWERCASE: "Password must contain at least one lowercase letter",
  NUMBER: "Password must contain at least one number",
  SPECIAL_CHARACTER: "Password must contain at least one special character",
  PASSWORD_REQUIRED: "Password is required",
  PASSWORD_MATCH: "Passwords must match",
  CONFIRM_PASSWORD: "Confirm Password is required",
  OTP_COUNT: "One Time Pin must be exactly 6 digits",
  OTP_REQUIRED: "One Time Pin is required",
  OTP_DIGIT: "One Time Pin must only contain digits",
};

export const PLACEHOLDER = {
  PASSWORD: "Enter your new password",
  NEW_PASSWORD: "Re-enter your new password",
  LOGIN_PASSWORD: "Enter your password",
  CUSTOME_MESSAGE: "Type custom message to send to user...",
  SEARCH: "Search by Name or Phone",
};

export const BUTTON = {
  RESET: "Reset Password",
  VERIFY_OTP: "Verify One Time Pin",
  SEND_MESSAGE: "Send Message to User",
  INTENT_CLASSIFICATION: "User Intent Classification",
  DOCTOR_QUESTION_LIST: "View/Edit User’s Doctor Question List",
  TODO_LIST: "View/Edit User’s To Do List",
  SCHEDULED_MESSAGES: "View Scheduled Messages to User",
  MEMORY_JOURNAL: "View Memory Journal",
  USER_PREFERENCES: "User Preferences",
  USER_SHOPPING: "User Shopping Behaviour",
  EDIT: "Edit",
  UNSUBSCRIBE:"Unsubscribe"
};

export const FIELD_HEADING = {
  LAST_RECEIPT: "Last Receipt Time",
  STATUS: "Status",
  NAME: "Name",
  PHONE: "Phone",
  DUE_DATE: "Due Date",
  EMAIL: "Email",
  GESTATIONAL_AGE: "Gestational Age",
  DATE_REG: "Date Registered",
  SMS_SENT: "# SMS Received",
};
export const TABLE_HEADING = {
  DAY: "Day",
  SCHEDULE_TIME: "Schedule Time",
  MESSAGE: "Message",
  OCCASION: "Occasion",
  DATE: "Date",
  DAYS_REMAIN: "Days Remaining",
  WEEK: "Week",
  ACTION: "Action",
  DAY_OF_PREGNANCY: "Day of Pregnancy",
  DAY_REMIANING: "Days Remaining",
  COMPLETION: "Completion",
  TYPE_OF_MESSAGE: "Type of Message",
  HIGHLIGHT: "Highlight",
  TODO_LIST: "To do List Items",
};

export const PAGE_HEADING = {
  CONVERSATION_HISTORY: "Conversation History",
  ACTIONS: "Actions",
};

export const TIMEZONES = {
  PST: { label: "Pacific Time", value: "America/Los_Angeles" },
  MST: { label: "Mountain Time", value: "America/Denver" },
  CT: { label: "Central Time", value: "America/Chicago" },
  EST: { label: "Eastern Time", value: "America/New_York" },
  GMT: { label: "Greenwich Mean Time", value: "Etc/GMT" },
};


export const SUBSCRIPTION_PLANS = {

  daily: { label: "Daily", amount: 1.00, duration: 1, offer:"" ,mode:"subscription",type:"all", priceId:process.env.REACT_APP_SUBSCRIPTION_DAILY_PRICE_ID },
  monthly: { label: "Monthly", amount: 9.99, duration: 1, offer:"" ,mode:"subscription",type:"all", priceId:process.env.REACT_APP_SUBSCRIPTION_PRICE_ID },
  annual: { label: "Full Pregnancy", amount: 30, duration: 1, offer:"(up to 50% off)", mode:"payment", type:process.env.REACT_APP_PAYMENT_TYPE_KEY1, priceId:process.env.REACT_APP_FULL_PAYMENT_50_OFF_PRICE_ID },
  annual2: { label: "Full Pregnancy", amount: 24, duration: 1,offer:"(up to 60% off)",mode:"payment", type:process.env.REACT_APP_PAYMENT_TYPE_KEY2, priceId:process.env.REACT_APP_FULL_PAYMENT_60_OFF_PRICE_ID },

  // quarterly: { label: "3 Months", amount: 27.99, duration: 3 },
  // semiannual: { label: "6 Months", amount: 49.99, duration: 6 },
  // annual: { label: "9 Months", amount: 69.99, duration: 9 },
};

export const DATE = {
  JOURNAL_FORMAT: "MM/DD/YY",
};
